import React from 'react';
import PropTypes from 'prop-types';

import {Box, Paper, Stack, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const ShiftFeedbackTile = (props) => {
  const {feedbackData} = props;
  const feedback = feedbackData.feedback || {};
  const tileRef = React.useRef(null);

  React.useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      tileRef.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, []);

  const rows = [
    ['schedule.eventDetail.ShiftFeedbackSection.CaregiverHappiness', feedback.caregiverHappinessResponse],
    ['schedule.eventDetail.ShiftFeedbackSection.CareQuiltHappiness', feedback.carequiltHappinessResponse],
    ['schedule.eventDetail.ShiftFeedbackSection.ImprovementAreas',
      Array.isArray(feedback.improvementResponses) ? feedback.improvementResponses.join(', ') : null],
    ['schedule.eventDetail.ShiftFeedbackSection.AdditionalComments', feedback.additionalComments],
    ['schedule.eventDetail.ShiftFeedbackSection.FollowUpRequired', feedback.isFollowUpRequired === undefined ? null :
      translate(feedback.isFollowUpRequired ? 'generic.Yes' : 'generic.No')],
    ['schedule.eventDetail.ShiftFeedbackSection.BestFollowUpTime', feedback.bestFollowUpTime],
    ['schedule.eventDetail.ShiftFeedbackSection.PrivateFeedback', feedback.isFeedbackPrivacyRequired === undefined ? null :
      translate(feedback.isFeedbackPrivacyRequired ? 'generic.Yes' : 'generic.No')],
  ].filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '');

  return (
    <Paper
      id='shift-feedback'
      ref={tileRef}
      sx={{p: 2, mb: 2, border: '2px solid', borderColor: 'warning.main'}}
    >
      <Typography variant='h6' sx={{mb: 1.5}}>
        <Translate expression='schedule.eventDetail.ShiftFeedbackSection.Title' />
      </Typography>
      <Stack spacing={1}>
        {
          rows.map(([labelExpression, value]) => (
            <Box key={labelExpression}>
              <Typography sx={{fontSize: '12px', fontWeight: 700, color: 'text.secondary'}}>
                <Translate expression={labelExpression} />
              </Typography>
              <Typography sx={{whiteSpace: 'pre-wrap'}}>{value}</Typography>
            </Box>
          ))
        }
      </Stack>
    </Paper>
  );
};

ShiftFeedbackTile.propTypes = {
  feedbackData: PropTypes.shape({
    feedback: PropTypes.object,
  }).isRequired,
};

export default ShiftFeedbackTile;
